export default __webpack_public_path__ + "static/media/P305 zu P316.7e20a712.mp3";